import { JSX } from 'react';
import { ComponentTypeIconName, IconName, IconSize } from './types';
import { Icon } from './Icon';
import { isFontAwesomeIconName, isSVGIcon } from './utils';
import { SvgIcon } from './SvgIcon';
import { FontAwesomeIcon } from './FontAwesomeIcon';

export const ComponentTypeIcon = ({
  name,
  color,
  image,
  size = IconSize.MEDIUM,
}: {
  name: ComponentTypeIconName | null;
  color: string;
  image: string | null;
  size?: IconSize;
}): JSX.Element => {
  if (image) {
    return <Icon iconSize={size} src={image} />;
  }

  if (isSVGIcon(name)) {
    return <SvgIcon iconId={name} color={color} width={size} height={size} />;
  }

  if (isFontAwesomeIconName(name)) {
    return <FontAwesomeIcon iconName={name} color={color} iconSize={size} />;
  }

  return (
    <Icon iconName={IconName.SHOW_COMPONENT} color={color} iconSize={size} />
  );
};
